export default __webpack_public_path__ + "static/media/ColorShiftsCompleted.4622dbff.svg";